import { COLLECTIONS, store } from './shared';
import { AVALIACAO_SESSOES } from '../../../enums';

const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

const normalizeCreatePayload = payload => ({
  ...payload,
  sessao_id: payload && payload.sessao_id ? payload.sessao_id : null,
  modelos_id: Array.isArray(payload && payload.modelos_id) ? payload.modelos_id : [],
  titulo: payload && payload.titulo ? payload.titulo : '',
  questao: payload && payload.questao ? payload.questao : payload && payload.titulo ? payload.titulo : '',
  modelos: Array.isArray(payload && payload.modelos) ? payload.modelos : Array.isArray(payload && payload.modelos_id) ? payload.modelos_id : [],
  sessao_label:
    (payload && payload.sessao_label) ||
    (payload && payload.sessao_id && AVALIACAO_SESSOES[payload.sessao_id]
      ? AVALIACAO_SESSOES[payload.sessao_id].label
      : ''),
  discriminacao: payload && payload.discriminacao ? payload.discriminacao : '',
  tipo_resposta: payload && payload.tipo_resposta ? payload.tipo_resposta : ''
});

const mergeUpdatePayload = (current, payload) => {
  const merged = {
    ...current,
    ...payload
  };

  if (hasOwn(payload, 'sessao_id')) {
    merged.sessao_id = payload.sessao_id;
  }
  if (hasOwn(payload, 'modelos_id')) {
    merged.modelos_id = payload.modelos_id;
  }
  if (hasOwn(payload, 'titulo')) {
    merged.titulo = payload.titulo;
  }
  if (hasOwn(payload, 'discriminacao')) {
    merged.discriminacao = payload.discriminacao;
  }
  if (hasOwn(payload, 'tipo_resposta')) {
    merged.tipo_resposta = payload.tipo_resposta;
  }

  return merged;
};

const update = async (id, payload) => {
  const currentResult = await store.getById(COLLECTIONS.questoes, id);

  if (!currentResult.ok || !currentResult.data) {
    return currentResult;
  }

  const nextPayload = mergeUpdatePayload(currentResult.data, payload || {});
  return store.update(COLLECTIONS.questoes, id, nextPayload);
};

const questoesRepo = {
  list: async () => {
    const result = await store.list(COLLECTIONS.questoes);

    if (!result.ok) {
      return result;
    }

    const items = Array.isArray(result.data) ? result.data.map(normalizeCreatePayload) : [];
    return { ok: true, data: items, error: null };
  },
  getById: async id => store.getById(COLLECTIONS.questoes, id),
  create: async payload => store.create(COLLECTIONS.questoes, normalizeCreatePayload(payload)),
  update,
  remove: async id => store.remove(COLLECTIONS.questoes, id)
};

export default questoesRepo;
